import { administratorRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { competitionStagePageConfig } from "./competitionStagePageConfig";

export const competitionStageRecordDefinition: RecordDefinition = {
  path: "/competition-stage",
  entityName: "dwcompetitionstage",
  listRoute: "/competition-stages",
  backTitle: "Back to competition stages",
  allowedRoles: administratorRoles,
  config: competitionStagePageConfig,
  // The warehouse holds this record, and the view resolver never sees it.
  authorable: false,
  identity: {
    titleFields: ["name"],
    fallbackTitle: "Competition Stage",
    newRecordTitle: "New Competition Stage",
  },
};
